module.exports = __webpack_public_path__ + "static/skyline-sydney@2x-189c2154bc8d41d8b0fc46bc1cb6f547.png";